import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Main.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import MobileMainPage from "./MobileMainPage";

const MainPage = () => {
  const listRef = useRef(null);
  const thumbRef = useRef(null);

  useEffect(() => {
    const list = listRef.current;
    const thumb = thumbRef.current;

    const handleScroll = () => {
      const scrollTop = list.scrollTop;
      const scrollHeight = list.scrollHeight - list.clientHeight;
      const maxThumbMove = list.clientHeight - thumb.offsetHeight;

      const progress = scrollTop / scrollHeight;
      thumb.style.transform = `translateY(${progress * maxThumbMove}px)`;
    };

    list.addEventListener("scroll", handleScroll);
    return () => list.removeEventListener("scroll", handleScroll);
  }, []);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => {
      const ua = navigator.userAgent.toLowerCase();
      const isUA = /android|iphone|ipad|ipod|mobile|opera mini|blackberry/.test(ua);
      const isWidth = window.innerWidth <= 768;

      setIsMobile(isUA || isWidth);
    };

    check();
    window.addEventListener("resize", check);

    return () => window.removeEventListener("resize", check);
  }, []);

  if (isMobile) {
    return <MobileMainPage />;
  }

  const casesData = [
    
    {
      number: "01",
      name: "Floya",
      tags: "Telegram WebApp магазин",
      image: "/images/case2.png",
    },
    {
      number: "02",
      name: "Ramstore",
      tags: "Telegram WebApp магазин",
      image: "/images/case3.png",
    },
    {
      number: "03",
      name: "Хозяин горбушки",
      tags: "Telegram WebApp магазин",
      image: "/images/case4.png",
    },
    {
      number: "04",
      name: "Mr.Bond",
      tags: "Telegram WebApp магазин",
      image: "/images/case5.png",
    },
    {
      number: "05",
      name: "Молодость прикамья",
      tags: "Сайт молодости прикамья",
      image: "/images/case1.png",
    },
  ];

  const gamesData = [
    {
      name: "Highway Run",
      genre: "Аркада, раннер, уличные гонки, сбор монет, турниры, бесконечный забег, динамичный геймплей",
      status: "В разработке",
      year: "2025",
      image: "/images/game1.png"
    },
    {
      name: "Хранитель рощи",
      genre: "Приключенческая RPG с элементами упрощенного life-sim, защиты базы и построения отношений",
      status: "В разработке",
      year: "2025",
      image: "/images/game2.png"
    },
    {
      name: "Timber Dojo",
      genre: "Аркада, карате, реакция и тайминг, дерево-испытания, динамичный геймплей, боевые исскуства",
      status: "Демо",
      year: "2025",
      image: "/images/game3.png"
    },
  ];


  const teamData = [
    {
      name: "Павел Таймер",
      image: "/images/pavel.png",
      desc: [
        "UI/UX-дизайнер, веб-дизайнер и гейм-дизайнер.",
        "Специалист в работе с Искусственным интеллектом и верстке на Tilda.",
        "Сооснователь команды BunkerDev."
      ]
    },
    {
      name: "Михаил Луканин",
      image: "/images/misha.png",
      desc: [
        "Frontend-разработчик, создатель приложений и интерактивных продуктов.",
        "Опыт работы с современными фреймворками и игровыми технологиями.",
        "Основатель BunkerDev."
      ]
    },
    {
      name: "Егор Гайнцев",
      image: "/images/egor.png",
      desc: [
        "Эксперт в веб-дизайне, UI/UX и визуальных концепциях.",
        "Разрабатывает дизайн-системы и адаптивные интерфейсы.",
      ]
    }
  ];

  return (
    <div className="main">
      <div className="background-one" style={{ backgroundImage: `url("/images/background-1.png")` }}></div>
      <div className="background-two"></div>
      <div className="background-three" style={{ backgroundImage: `url("/images/background-2.png")` }}></div>
      <div className="background-four"></div>
      <div className="background-five" style={{ backgroundImage: `url("/images/space-cosmo.png")` }}></div>
      <div className="background-six" style={{ backgroundImage: `url("/images/background-4.png")` }}></div>
      <div className="background-seven"></div>
      <div className="background-eight" style={{ backgroundImage: `url("/images/background-5.jpg")` }}></div>
      <div className="background-nine"></div>
      <div className="background-ten" style={{ backgroundImage: `url("/images/background-6.jpg")` }}></div>
      <header className="header">
        <div className="special-container">
          <div className="header__inner d-flex justify-content-between align-items-center">

            <div className="header__logo">
              <img className="image-logo" src="/images/logo.png" />
              <img className="text-logo" src="/images/logo-text.svg" />
            </div>

            <nav className="header__nav">
              <ul className="header__nav-list">
                <li className="header__nav-item" onClick={() => document.getElementById("cases").scrollIntoView({ behavior: "smooth" })}>Кейсы / Проекты</li>
                <li className="header__nav-item" onClick={() => document.getElementById("team").scrollIntoView({ behavior: "smooth" })}>Команда</li>
                <li className="header__nav-item" onClick={() => document.getElementById("games").scrollIntoView({ behavior: "smooth" })}>Игры</li>
              </ul>
            </nav>

            <div className="header__social">
              <a className="header__social-link" target="_blank" href="https://t.me/bunkerdevs"><img className="image-icon-logo" src="/images/telegram-icon.svg" /></a>
              <a className="header__social-link" target="_blank" href="https://vk.com/bunkerdev"><img className="image-icon-logo" src="/images/vk-icon.svg" /></a>
            </div>

          </div>
        </div>
      </header>

      <section className="hero">
        <div className="special-container">
          <div className="hero__inner">

            <h1 className="hero__title" >
              Мы создаём решения, <span className="text-white">которые</span> <br /><span className="text-white">формируют будущее</span>
            </h1>

            <p className="hero__subtitle">
              Digital агентство полного цикла: <span>сайты, боты, приложения, игры, дизайн</span>
            </p>

            <div className="hero__buttons">
              <a style={{textDecoration: "none"}} href="https://t.me/thehypeprogrammer" target="_blank" className="hero__btn hero__btn--primary">Связаться с нами <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_10_7944)">
                  <path d="M15.1666 21H3.49998C2.56504 21 1.68613 20.6359 1.02509 19.9748C0.364058 19.3138 0 18.4348 0 17.5V5.83333C0 4.89842 0.364099 4.01952 1.02513 3.35848C1.68617 2.69745 2.56508 2.33335 3.50002 2.33335H8.16667C8.81104 2.33335 9.33335 2.85565 9.33335 3.50002C9.33335 4.14439 8.81104 4.66669 8.16667 4.66669H3.49998C3.18833 4.66669 2.89539 4.78806 2.67507 5.00838C2.45475 5.2287 2.33335 5.52168 2.33335 5.83333V17.5C2.33335 17.8116 2.45471 18.1046 2.67507 18.325C2.89539 18.5452 3.18833 18.6667 3.49998 18.6667H15.1666C15.4782 18.6667 15.7712 18.5453 15.9915 18.3249C16.2119 18.1046 16.3332 17.8116 16.3332 17.4999V12.8333C16.3332 12.189 16.8556 11.6667 17.4999 11.6667C18.1443 11.6667 18.6667 12.189 18.6667 12.8333V17.5C18.6667 18.4349 18.3026 19.3138 17.6415 19.9749C16.9804 20.6359 16.1015 21 15.1666 21ZM8.16667 14C7.86807 14 7.5695 13.8861 7.34172 13.6583C6.88613 13.2027 6.88613 12.4639 7.34172 12.0083L17.0167 2.33335H12.8333C12.189 2.33335 11.6667 1.81104 11.6667 1.16667C11.6667 0.522308 12.189 7.70486e-07 12.8333 7.70486e-07H19.8333C20.138 -0.00034962 20.4306 0.118821 20.6483 0.331904L20.6484 0.331985L20.6507 0.334268L20.6513 0.33492L20.6531 0.336713L20.6543 0.337895L20.6556 0.339199L20.6582 0.341726L20.6607 0.344252L20.6619 0.345557L20.6631 0.346738C20.664 0.34751 20.6648 0.34834 20.6656 0.349224L20.6679 0.351547L20.6679 0.351629C20.881 0.569371 21.0002 0.861991 20.9998 1.16663V8.16663C20.9998 8.811 20.4775 9.33331 19.8331 9.33331C19.1888 9.33331 18.6665 8.811 18.6665 8.16663V3.98329L8.99142 13.6583C8.76381 13.8861 8.46524 14 8.16667 14Z" fill="white" />
                </g>
                <defs>
                  <clipPath id="clip0_10_7944">
                    <rect width="21" height="21" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              </a>
              <button className="hero__btn hero__btn--games" onClick={() => document.getElementById("games").scrollIntoView({ behavior: "smooth" })}>Наши игровые проекты <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_10_7949)">
                  <path d="M20.9999 14.9214C20.9507 12.1816 20.627 9.41099 20.0963 6.61454C19.664 4.67163 18.1087 2.94119 15.6236 2.81445C13.7889 2.73898 13.4341 3.78406 11.3555 3.76396C10.7862 3.76027 10.2173 3.76027 9.64799 3.76396C7.5689 3.78406 7.2133 2.73898 5.37949 2.81445C2.89394 2.94119 1.29023 4.66712 0.905095 6.61454C0.373943 9.41099 0.0503295 12.1812 0.00152091 14.921C-0.0103736 16.8287 1.87306 18.0977 3.11584 18.1846C5.51648 18.3659 7.42371 14.1327 8.87689 14.1323C9.96011 14.1385 11.0429 14.1389 12.1261 14.1323C13.5797 14.1323 15.4853 18.3663 17.8876 18.1851C19.13 18.0981 21.0622 16.8205 21.0003 14.9214H20.9999ZM7.8314 9.57546H6.71168V10.6952C6.71168 11.1677 6.32859 11.5508 5.85609 11.5508C5.38359 11.5508 5.0005 11.1677 5.0005 10.6952V9.57546H3.88078C3.40828 9.57546 3.02519 9.19238 3.02519 8.71988C3.02519 8.24738 3.40828 7.86429 3.88078 7.86429H5.0005V6.74456C5.0005 6.27206 5.38359 5.88898 5.85609 5.88898C6.32859 5.88898 6.71168 6.27206 6.71168 6.74456V7.86429H7.8314C8.3039 7.86429 8.68699 8.24738 8.68699 8.71988C8.68699 9.19238 8.3039 9.57546 7.8314 9.57546ZM14.7454 11.5504C14.0756 11.5684 13.5186 11.0393 13.5006 10.3699C13.4829 9.6981 14.0125 9.14029 14.6818 9.12306C15.352 9.10624 15.9098 9.63493 15.9271 10.3051C15.9439 10.9753 15.4152 11.5331 14.7454 11.5504ZM16.7654 8.31628C16.0956 8.33515 15.5374 7.80564 15.519 7.13585C15.5021 6.46484 16.0308 5.90785 16.701 5.88939C17.372 5.87175 17.929 6.40126 17.9471 7.07146C17.9647 7.74124 17.4348 8.29947 16.7654 8.31628Z" fill="white" />
                </g>
                <defs>
                  <clipPath id="clip0_10_7949">
                    <rect width="21" height="21" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              </button>
              <button className="hero__btn hero__btn--cases" onClick={() => document.getElementById("cases").scrollIntoView({ behavior: "smooth" })}>Посмотреть кейсы <svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.9053 3.3962H14.3825V1.57372C14.3825 0.705942 13.6765 0 12.8087 0H8.19098C7.3232 0 6.61722 0.705942 6.61722 1.57372V3.3962H2.09439C0.942234 3.3962 0.00485247 4.33358 0.00485247 5.48574C0.00485247 6.5323 -0.102328 7.47218 0.690758 8.52916C1.13947 9.12717 1.75611 9.55377 2.47396 9.76275L9.44482 11.7924C10.1338 11.9933 10.8658 11.9933 11.5548 11.7924L18.5256 9.76275C19.2435 9.55373 19.8601 9.12717 20.3088 8.52916C21.1055 7.46743 20.9947 6.51789 20.9947 5.48574C20.9948 4.33358 20.0574 3.3962 18.9053 3.3962ZM7.9502 1.57372C7.95028 1.50989 7.97567 1.4487 8.02081 1.40357C8.06595 1.35844 8.12715 1.33305 8.19098 1.33299H12.8087C12.8725 1.33305 12.9337 1.35844 12.9789 1.40357C13.024 1.4487 13.0494 1.50989 13.0495 1.57372V3.3962H7.9502V1.57372Z" fill="white" />
                <path d="M18.8983 11.0414C11.3794 13.2305 11.4767 13.2748 10.4998 13.2748C9.52991 13.2748 9.76001 13.2712 2.10138 11.0414C1.29388 10.8062 0.578734 10.3729 0.00488281 9.77539V16.1719C0.00488281 17.3241 0.942222 18.2614 2.09442 18.2614H18.9053C20.0574 18.2614 20.9948 17.3241 20.9948 16.1719V9.77539C20.4209 10.3728 19.7058 10.8062 18.8983 11.0414Z" fill="white" />
              </svg>
              </button>
            </div>

          </div>
        </div>
      </section>
      <section className="cases">
        <div className="special-container">

          <h1 className="cases__title" id="cases">
            Кейсы / Проекты
          </h1>
          <div className="cases__wrapper">
            <div className="cases__list" ref={listRef}>

              {casesData.map((item, index) => (
                <div className="cases__item" key={index}>

                  <div className="cases__item-info">
                    <div className="cases__number">{item.number}</div>
                    <h2 className="cases__name">{item.name}</h2>
                    <p className="cases__tags">{item.tags}</p>
                  </div>

                  <div className="cases__item-preview">
                    <img className="image-case" src={item.image} alt={item.name} />
                  </div>

                </div>
              ))}
            </div>
            <div className="cases__scrollbar">
              <div className="cases__scrollbar-track"></div>
              <div className="cases__scrollbar-thumb" ref={thumbRef}></div>
            </div>
          </div>
        </div>
      </section>
      <section className="team">
        <div className="special-container">
          <h1 className="team__title" id="team">Команда</h1>

          <div className="team__swiper-wrapper">
            <Swiper
              spaceBetween={40}
              slidesPerView={3}
              navigation={false}
              initialSlide={1}
              centeredSlides={true}
              className="team__swiper"
            >
              {teamData.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="team__card">

                    <div className="team__image">
                      <img src={item.image} alt={item.name} />
                    </div>

                    <div className="team__info">
                      <h3 className="team__name">{item.name}</h3>
                      <ul className="team__desc">
                        {item.desc.map((line, i) => (
                          <li key={i}>{line}</li>
                        ))}
                      </ul>

                    </div>

                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>
      <section className="games">
        <div className="special-container">

          <h1 className="games__title" id="games">Игры / GameDev</h1>

          <p className="games__subtitle">
            Мы разрабатываем игровые проекты от идеи и сценария <br />
            до готового игрового окружения. <span>Каждый проект — это продуманный UX, <br />
              стильная визуальная атмосфера и уникальная механика.</span>
          </p>

          <div className="games__list">
            {gamesData.map((item, index) => (
              <div className="games__item" key={index}>

                <div className="games__image">
                  <img src={item.image} alt={item.name} />
                </div>

                <div className="games__content">
                  <h3 className="games__name">{item.name}</h3>

                  <p className="games__genre">{item.genre}</p>

                  <div className="games__info">
                    <div className="games__row">
                      <span className="games__label">Статус:</span>
                      <span className="games__value">{item.status}</span>
                    </div>
                    <div className="games__row">
                      <span className="games__label">Начало разработки:</span>
                      <span className="games__value">{item.year}</span>
                    </div>
                  </div>
                </div>

              </div>
            ))}
          </div>

        </div>
      </section>
      <section className="cooperation">
        <div className="special-container">

          <div className="cooperation__card">

            <div className="cooperation__content">
              <h1 className="cooperation__title">Сотрудничество</h1>

              <p className="cooperation__text">
                Мы открыты к сотрудничеству с компаниями и специалистами. 
                <span> Если вы хотите стать нашим партнёром или присоединиться к команде —
                будем рады обсудить детали и возможные форматы взаимодействия.</span>
              </p>

              
            </div>
            <a style={{textDecoration: "none"}} href="https://t.me/thehypeprogrammer?text=Добрый день! Я по поводу сотрудничества с BunkerDev" target="_blank" className="cooperation__cta">
                Сотрудничество
                <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.1666 21H3.49998C2.56504 21 1.68613 20.6359 1.02509 19.9748C0.364058 19.3138 0 18.4348 0 17.5V5.83333C0 4.89842 0.364099 4.01952 1.02513 3.35848C1.68617 2.69745 2.56508 2.33335 3.50002 2.33335H8.16667C8.81104 2.33335 9.33335 2.85565 9.33335 3.50002C9.33335 4.14439 8.81104 4.66669 8.16667 4.66669H3.49998C3.18833 4.66669 2.89539 4.78806 2.67507 5.00838C2.45475 5.2287 2.33335 5.52168 2.33335 5.83333V17.5C2.33335 17.8116 2.45471 18.1046 2.67507 18.325C2.89539 18.5452 3.18833 18.6667 3.49998 18.6667H15.1666C15.4782 18.6667 15.7712 18.5453 15.9915 18.3249C16.2119 18.1046 16.3332 17.8116 16.3332 17.4999V12.8333C16.3332 12.189 16.8556 11.6667 17.4999 11.6667C18.1443 11.6667 18.6667 12.189 18.6667 12.8333V17.5C18.6667 18.4349 18.3026 19.3138 17.6415 19.9749C16.9804 20.6359 16.1015 21 15.1666 21ZM8.16667 14C7.86807 14 7.5695 13.8861 7.34172 13.6583C6.88613 13.2027 6.88613 12.4639 7.34172 12.0083L17.0167 2.33335H12.8333C12.189 2.33335 11.6667 1.81104 11.6667 1.16667C11.6667 0.522308 12.189 7.70486e-07 12.8333 7.70486e-07H19.8333C20.138 -0.00034962 20.4306 0.118821 20.6483 0.331904L20.6484 0.331985L20.6507 0.334268L20.6513 0.33492L20.6531 0.336713L20.6543 0.337895L20.6556 0.339199L20.6582 0.341726L20.6607 0.344252L20.6619 0.345557L20.6631 0.346738C20.664 0.34751 20.6648 0.34834 20.6656 0.349224L20.6679 0.351547L20.6679 0.351629C20.881 0.569371 21.0002 0.861991 20.9998 1.16663V8.16663C20.9998 8.811 20.4775 9.33331 19.8331 9.33331C19.1888 9.33331 18.6665 8.811 18.6665 8.16663V3.98329L8.99142 13.6583C8.76381 13.8861 8.46524 14 8.16667 14Z" fill="white"/>
</svg>
              </a>
            <div className="cooperation__image-wrapper">
              <img className="cooperation__image" src="/images/background-phone.png" alt="phones" />
            </div>

          </div>

          <div className="cooperation__buttons">
            <a style={{textDecoration: "none"}} href="https://t.me/thehypeprogrammer" className="cooperation__btn cooperation__btn--primary">Связаться с нами <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_10_7944)">
                <path d="M15.1666 21H3.49998C2.56504 21 1.68613 20.6359 1.02509 19.9748C0.364058 19.3138 0 18.4348 0 17.5V5.83333C0 4.89842 0.364099 4.01952 1.02513 3.35848C1.68617 2.69745 2.56508 2.33335 3.50002 2.33335H8.16667C8.81104 2.33335 9.33335 2.85565 9.33335 3.50002C9.33335 4.14439 8.81104 4.66669 8.16667 4.66669H3.49998C3.18833 4.66669 2.89539 4.78806 2.67507 5.00838C2.45475 5.2287 2.33335 5.52168 2.33335 5.83333V17.5C2.33335 17.8116 2.45471 18.1046 2.67507 18.325C2.89539 18.5452 3.18833 18.6667 3.49998 18.6667H15.1666C15.4782 18.6667 15.7712 18.5453 15.9915 18.3249C16.2119 18.1046 16.3332 17.8116 16.3332 17.4999V12.8333C16.3332 12.189 16.8556 11.6667 17.4999 11.6667C18.1443 11.6667 18.6667 12.189 18.6667 12.8333V17.5C18.6667 18.4349 18.3026 19.3138 17.6415 19.9749C16.9804 20.6359 16.1015 21 15.1666 21ZM8.16667 14C7.86807 14 7.5695 13.8861 7.34172 13.6583C6.88613 13.2027 6.88613 12.4639 7.34172 12.0083L17.0167 2.33335H12.8333C12.189 2.33335 11.6667 1.81104 11.6667 1.16667C11.6667 0.522308 12.189 7.70486e-07 12.8333 7.70486e-07H19.8333C20.138 -0.00034962 20.4306 0.118821 20.6483 0.331904L20.6484 0.331985L20.6507 0.334268L20.6513 0.33492L20.6531 0.336713L20.6543 0.337895L20.6556 0.339199L20.6582 0.341726L20.6607 0.344252L20.6619 0.345557L20.6631 0.346738C20.664 0.34751 20.6648 0.34834 20.6656 0.349224L20.6679 0.351547L20.6679 0.351629C20.881 0.569371 21.0002 0.861991 20.9998 1.16663V8.16663C20.9998 8.811 20.4775 9.33331 19.8331 9.33331C19.1888 9.33331 18.6665 8.811 18.6665 8.16663V3.98329L8.99142 13.6583C8.76381 13.8861 8.46524 14 8.16667 14Z" fill="white" />
              </g>
              <defs>
                <clipPath id="clip0_10_7944">
                  <rect width="21" height="21" fill="white" />
                </clipPath>
              </defs>
            </svg></a>
            <button onClick={() => document.getElementById("games").scrollIntoView({ behavior: "smooth" })} className="cooperation__btn cooperation__btn--games">Наши игровые проекты <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_10_7949)">
                <path d="M20.9999 14.9214C20.9507 12.1816 20.627 9.41099 20.0963 6.61454C19.664 4.67163 18.1087 2.94119 15.6236 2.81445C13.7889 2.73898 13.4341 3.78406 11.3555 3.76396C10.7862 3.76027 10.2173 3.76027 9.64799 3.76396C7.5689 3.78406 7.2133 2.73898 5.37949 2.81445C2.89394 2.94119 1.29023 4.66712 0.905095 6.61454C0.373943 9.41099 0.0503295 12.1812 0.00152091 14.921C-0.0103736 16.8287 1.87306 18.0977 3.11584 18.1846C5.51648 18.3659 7.42371 14.1327 8.87689 14.1323C9.96011 14.1385 11.0429 14.1389 12.1261 14.1323C13.5797 14.1323 15.4853 18.3663 17.8876 18.1851C19.13 18.0981 21.0622 16.8205 21.0003 14.9214H20.9999ZM7.8314 9.57546H6.71168V10.6952C6.71168 11.1677 6.32859 11.5508 5.85609 11.5508C5.38359 11.5508 5.0005 11.1677 5.0005 10.6952V9.57546H3.88078C3.40828 9.57546 3.02519 9.19238 3.02519 8.71988C3.02519 8.24738 3.40828 7.86429 3.88078 7.86429H5.0005V6.74456C5.0005 6.27206 5.38359 5.88898 5.85609 5.88898C6.32859 5.88898 6.71168 6.27206 6.71168 6.74456V7.86429H7.8314C8.3039 7.86429 8.68699 8.24738 8.68699 8.71988C8.68699 9.19238 8.3039 9.57546 7.8314 9.57546ZM14.7454 11.5504C14.0756 11.5684 13.5186 11.0393 13.5006 10.3699C13.4829 9.6981 14.0125 9.14029 14.6818 9.12306C15.352 9.10624 15.9098 9.63493 15.9271 10.3051C15.9439 10.9753 15.4152 11.5331 14.7454 11.5504ZM16.7654 8.31628C16.0956 8.33515 15.5374 7.80564 15.519 7.13585C15.5021 6.46484 16.0308 5.90785 16.701 5.88939C17.372 5.87175 17.929 6.40126 17.9471 7.07146C17.9647 7.74124 17.4348 8.29947 16.7654 8.31628Z" fill="white" />
              </g>
              <defs>
                <clipPath id="clip0_10_7949">
                  <rect width="21" height="21" fill="white" />
                </clipPath>
              </defs>
            </svg></button>
            <button onClick={() => document.getElementById("cases").scrollIntoView({ behavior: "smooth" })} className="cooperation__btn cooperation__btn--cases">Посмотреть кейсы <svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.9053 3.3962H14.3825V1.57372C14.3825 0.705942 13.6765 0 12.8087 0H8.19098C7.3232 0 6.61722 0.705942 6.61722 1.57372V3.3962H2.09439C0.942234 3.3962 0.00485247 4.33358 0.00485247 5.48574C0.00485247 6.5323 -0.102328 7.47218 0.690758 8.52916C1.13947 9.12717 1.75611 9.55377 2.47396 9.76275L9.44482 11.7924C10.1338 11.9933 10.8658 11.9933 11.5548 11.7924L18.5256 9.76275C19.2435 9.55373 19.8601 9.12717 20.3088 8.52916C21.1055 7.46743 20.9947 6.51789 20.9947 5.48574C20.9948 4.33358 20.0574 3.3962 18.9053 3.3962ZM7.9502 1.57372C7.95028 1.50989 7.97567 1.4487 8.02081 1.40357C8.06595 1.35844 8.12715 1.33305 8.19098 1.33299H12.8087C12.8725 1.33305 12.9337 1.35844 12.9789 1.40357C13.024 1.4487 13.0494 1.50989 13.0495 1.57372V3.3962H7.9502V1.57372Z" fill="white" />
              <path d="M18.8983 11.0414C11.3794 13.2305 11.4767 13.2748 10.4998 13.2748C9.52991 13.2748 9.76001 13.2712 2.10138 11.0414C1.29388 10.8062 0.578734 10.3729 0.00488281 9.77539V16.1719C0.00488281 17.3241 0.942222 18.2614 2.09442 18.2614H18.9053C20.0574 18.2614 20.9948 17.3241 20.9948 16.1719V9.77539C20.4209 10.3728 19.7058 10.8062 18.8983 11.0414Z" fill="white" />
            </svg></button>
          </div>

          <p className="cooperation__copyright">
            © Все права защищены 2025
          </p>
        </div>
      </section>
    </div>
  );
};

export default MainPage;